import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "knockout-container" }
const _hoisted_2 = { class: "py-6 px-8 d-flex justify-space-between" }
const _hoisted_3 = { class: "d-flex" }

import {ApiMap} from "@/api/type";
import {ref, watch} from "vue";
import {useApi} from "@/api/handler";
import {proposal} from "@/api";
import FileUpload from "@/components/FileUpload.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'KnockOut',
  props: {
    data: {}
  },
  emits: ['update'],
  setup(__props: any, { emit: __emit }) {

const props = __props
const emits = __emit
const GameStatus = ref<ApiMap['/game/status/:id']['resp'] | null>(null)
const gradeList = ref<ApiMap['/proposal/upload/first/xxt']['resp'] | null>(null)
const selectedTeam = ref<Array<number>>([])
const headers = [
    {title: '组号', value: 'teamId'},
    {title: '组长', value: 'teamName'},
    {title: '本回合分数', value: 'thisRoundScore'},
    {title: '提交时间', value: 'submitTime'},
    {title: '淘汰', value: 'status'},
]
const statusMap = ['未参赛', '已淘汰', '未淘汰']
const colorMap = ['', 'red', 'green']
const pageSize = ref<number>(100)

const useFirstUpload = (file: File) => {
  useApi({
    api: proposal.FirstUploadGrade(GameStatus.value!.id, file),
    onSuccess: resp => {
      gradeList.value = resp.data as ApiMap['/proposal/upload/first/xxt']['resp']
      emits('update')
    },
    tip: '上传成功'
  })
}

const useKnockoutTeam = () => {
  useApi({
    api: proposal.KnockoutTeam(GameStatus.value!.id, selectedTeam.value),
    onSuccess: resp => {
      if (!gradeList.value) return
      gradeList.value.forEach((v, i) => {
        if (selectedTeam.value.includes(v.teamId)) v.status = 0
      })
      selectedTeam.value = []
      emits('update')
    },
    tip: '淘汰成功'
  })
}

watch(() => props.data, () => {
  GameStatus.value = props.data ?? null
}, {immediate: true})

return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_data_table = _resolveComponent("v-data-table")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[3] || (_cache[3] = _createElementVNode("div", { class: "text-h5 text-indigo-lighten-2" }, "第一轮提案 淘汰赛", -1)),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(FileUpload, { onUpload: useFirstUpload }),
        _createVNode(_component_v_btn, {
          class: "ml-4",
          color: "red-lighten-2",
          onClick: useKnockoutTeam
        }, {
          default: _withCtx(() => _cache[2] || (_cache[2] = [
            _createTextVNode("淘汰选中")
          ])),
          _: 1,
          __: [2]
        })
      ])
    ]),
    _createVNode(_component_v_card, {
      class: "mx-4",
      style: {"overflow-y":"auto"}
    }, {
      default: _withCtx(() => [
        _cache[4] || (_cache[4] = _createElementVNode("div", { class: "py-4 d-flex text-h6 justify-center bg-indigo-lighten-2" }, "学习通答题情况", -1)),
        _createVNode(_component_v_data_table, {
          items: gradeList.value ?? [],
          height: "600",
          headers: headers,
          "show-select": "",
          "item-value": "teamId",
          "hide-default-footer": "",
          modelValue: selectedTeam.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedTeam).value = $event)),
          "items-per-page": pageSize.value,
          "onUpdate:itemsPerPage": _cache[1] || (_cache[1] = ($event: any) => ((pageSize).value = $event)),
          "no-data-text": "请先传入学习通数据"
        }, {
          "item.status": _withCtx(({ value }) => [
            _createVNode(_component_v_chip, {
              color: colorMap[value + 1]
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(statusMap[value + 1]), 1)
              ]),
              _: 2
            }, 1032, ["color"])
          ]),
          "item.teamId": _withCtx(({ value }) => [
            _createElementVNode("div", null, "第 " + _toDisplayString(value) + " 组", 1)
          ]),
          _: 1
        }, 8, ["items", "modelValue", "items-per-page"])
      ]),
      _: 1,
      __: [4]
    })
  ]))
}
}

})